import { Outlet } from "react-router";

import { Footer } from "./components/footer";
import { Header } from "./components/header";

export const HomeLayout = () => (
  <div className="overflow-x-hidden">
    <Header />
    <Outlet />
    <Footer />
  </div>
);
